import React, { useEffect, useRef } from "react";
import Chart from "chart.js/auto";
import "./Piechart.css";

import mont from "./mont.png";

const PieChart = ({ data }) => {
  const chartRef = useRef();
  const chartInstance = useRef(null);

  useEffect(() => {
    if (chartInstance.current) chartInstance.current.destroy();

    const ctx = chartRef.current.getContext("2d");
    chartInstance.current = new Chart(ctx, {
      type: "pie",
      data: {
        labels: ["Users", "Leaders", "Members"],
        datasets: [
          {
            data: data,
            backgroundColor: [
              "rgba(228, 199, 72, 1)",
              "rgba(201, 147, 51, 1)",
              "rgba(235, 214, 114, 1)",
            ],
            borderWidth: 0,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: true, // <-- keep perfect circle
        plugins: {
          legend: { display: false },
          tooltip: {
            enabled: true,
            callbacks: {
              label: function (context) {
                const label = context.label || "";
                const value = context.raw || 0;
                return `${label}: ${value}`;
              },
            },
          },
        },
      },
    });

    return () => {
      if (chartInstance.current) chartInstance.current.destroy();
    };
  }, [data]);

  return (
    <div className="piechart">
      <div className="hedar">
        <div className="subhed">Overall Distribution</div>
        <img src={mont} alt="" />
      </div>

      <div
        className="piecontainer "
        style={{
          width: "250px", // fixed width
          height: "120px", // fixed height to make circle
          margin: "0 auto",
        }}
      >
        <canvas ref={chartRef}></canvas>
      </div>

      <div className="split">
        <div className="spleft">
          <div className="he">
            <div className="bludot"></div>Users
          </div>
          <div className="mainhe">{data[0]}</div>
        </div>
        <div className="spleft">
          <div className="he">
            <div className="purdot"></div>Leaders
          </div>
          <div className="mainhe">{data[1]}</div>
        </div>
        <div className="spleft">
          <div className="he">
            <div className="yellowdot"></div>Members
          </div>
          <div className="mainhe">{data[2]}</div>
        </div>
      </div>
    </div>
  );
};

export default PieChart;
